import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

export const ModalSubmitAssessment = ({ isOpen, close, onAccept, onCancel, blockDays, showMessage = true }) => {
    const message = `After submitting, you will not be able to edit your answers for ${blockDays} days.`;

    return (
        <>
            <Modal isOpen={isOpen} toggle={close} centered size='md' className='close-circle'>
                <ModalHeader close={<></>} toggle={close} className='justify-content-center border-0 pb-0' cssModule={{ 'modal-title': 'modal-title libre-caslon-text-regular h4 mt-3' }}>Submit your answers?</ModalHeader>
                <ModalBody >
                    {!!showMessage && (
                        <div className='text-center'>
                            <p className='h5 font-weight-normal mb-4'>{message}</p>
                        </div>
                    )}
                    <div className="d-flex justify-content-center">
                        <Button color="green-light" size="sm" className="mx-3" onClick={onAccept}>
                            Yes, Submit
                        </Button>
                        <Button color="outline-green-light" size="sm" className="mx-3" onClick={onCancel}>
                            Go back and edit
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}